import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import '../styles/AvatarNotFound.scss';

function AvatarNotFound(props: { title: string }) {
  useEffect(() => {
    document.title = props.title;
  });
  return (
    <div className="avatar-not-found-page">
      <h1>We can't recognize you</h1>
      <p>Please, login through QR code</p>
      <p>or</p>
      <NavLink to="/contact-us">Contact us</NavLink>
    </div>
  );
}

export default AvatarNotFound;
